import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { useGameStatsStore } from '../../zustand/useGameStatsStore';

export const guildReducer = (scratch: StatsSnapshot) => {
  const guild = scratch.generators.guild;

  // Only update if ticksCount is a multiple of ticksToGenerate
  const ticksToGenerate = guild.ticksToGenerate ?? 1;
  if (useGameStatsStore.getState().getActiveTicksCount() % ticksToGenerate !== 0) {
    return;
  }

  const generatedThieves = guild.owned * guild.baseGeneration;

  // Apply upgrades somehow, somewhere...

  scratch.generators.thief.owned += generatedThieves;

  return;
};
